<ng-template #content let-modal>
  <div class="modal-header">
    <div class="col-md-12">
      <button class="btn pull-right" (click)="modal.dismiss('CANCEL')">
        <i class="fa fa-times"></i>
      </button>
      <span>
        {{ app.text.manufacturer.createNewManufacturer }}
      </span>
    </div>
  </div>
  <div class="modal-body">
    <div class="col-md-12">
      @for (field of columns; track field; let index = $index) {
        <app-field
          [model]="app.createManufacturer.model"
          [field]="field"
          [index]="index"
        ></app-field>
      }
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-cancel text-center m-1"
      (click)="modal.dismiss('CANCEL')"
      >
      {{ app.text.modal.cancel }}
    </button>
    <button
      class="btn btn-ok text-center m-1"
      (click)="save()"
      [disabled]="hasRequiredFields()"
      >
      {{ app.text.part.save }}
    </button>
  </div>
</ng-template>
